import { loadConfigFromRootDataset } from '../../../config';

const { backendUrl } = loadConfigFromRootDataset();

if (!backendUrl) {
    throw new Error('Missing backend URL');
}

export default backendUrl;
